import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import TestsRequests from 'services/tests';
import GridContainer from '@jumbo/components/GridContainer';
import { Box, Grid, Typography } from '@material-ui/core';
import CommentElement from './CommentElement';

const AllComments = ({ id }) => {
  const { commentsById } = useSelector(({ tests }) => tests);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(TestsRequests.getCommentsByID(id));
  }, []);

  return (
    <GridContainer>
      <Grid item xs={12}>
        {commentsById.length !== 0 ? (
          commentsById.map(item => <CommentElement data={item} key={item._id} />)
        ) : (
          <Box display={'flex'} justifyContent={'center'} marginY={'20px'} textAlign={'center'}>
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        )}
      </Grid>
    </GridContainer>
  );
};

export default AllComments;
